<div class="flex justify-between">
  <div
    class="toggle-container flex items-center gap-x-3 cursor-pointer"
    role="button"
    (click)="updateSalesforceAutomaticApprovalsFlag(contactList.id, !hasSalesforceAutomaticApprovals)">
    <app-toggle
      class="toggle"
      [ngModel]="hasSalesforceAutomaticApprovals"
      (ngModelChange)="updateSalesforceAutomaticApprovalsFlag(contactList.id, $event)">
    </app-toggle>

    <ng-container *ngVar="{ evidenceName: evidenceName$ | async, profileName: (profileName$ | async) } as data">
      @if (data.evidenceName && data.profileName) {
        <div class="flex flex-col">
          <span class="{{ hasSalesforceAutomaticApprovals ? 'text-navy-90' : 'text-navy-70' }} text-2xl">
            {{ contactList?.title }}
          </span>
          <span class="toggle-label {{ hasSalesforceAutomaticApprovals ? 'text-navy-90 font-bold' : 'text-navy-70' }} text-base">
            {{ buildTranslationKey('toggle.label') | translate: { evidenceName: data.evidenceName, profileName: data.profileName } }}
          </span>
        </div>
      } @else {
        <app-circle-loader class="w-4 h-4" [appearance]="'dark'"></app-circle-loader>
      }
    </ng-container>
  </div>

  <app-three-dots-menu
    class="three-dots-menu"
    [menuActions]="menuActions"
    [overlayPosition]="menuPosition">
  </app-three-dots-menu>
</div>

<span class="toggle-description text-navy-70">{{ buildTranslationKey('toggle.description') | translate }}</span>

<app-evidence class="salesforce-evidence" [class.opacity-40]="!hasSalesforceAutomaticApprovals" [evidenceId]="contactList.evidence_id" [allowDelete]="false"></app-evidence>
